import { version } from '../package.json'

export const SDK_NAME = 'mitojs'
export const SDK_VERSION = version
